<template>
  <div class="wrapper">
    <!-- <div class="logo_container">
      <img src="../assets/logo2.png" alt="" />
      <p>环保信用<span>ENVIRONMENTAL CREDIT</span></p>
      <p>环保信用评价管理平台</p>
    </div> -->
    <div class="login_box">
      <p class="title">环保信用评价管理平台</p>
      <div class="login_description">
        <div class="desc_container">
          <h2 style="text-align: center">贵州环保信用评价</h2>
          <!-- <p>
            开展企业环保信用建设工作，有利于倒逼企业自觉遵守环保法律法规和政策，让法律规定的环保义务和责任回归企业本位；有利于企业负责人增强道德自律意识，树立诚信经营“底线”和敬畏法律“高压线”，重塑和引领社会诚信风尚；有利于推动环保部门环境管理转型，建立环境管理“权力清单”、“责任清单”和“负面清单”三个清单，指导环保部门正确履职尽责，体现和重塑政府公信力；有利于支持和推动经济发展，尤其是良好以上企业的涌现，必将起到示范带动作用，同时也会增加企业对外竞争的“含金量”和美誉度。
          </p> -->
          <div>
            <p>
              环保信用评价，是指生态环境部门根据企业环境行为信息，按照规定的指标、方法和程序，对企业环境行为进行信用评价，确定信用等级，并向社会公开，供公众监督和有关部门、机构及组织应用的环境管理手段。环保信用评价是社会诚信和现代环境治理体系建设的重要组成部分，是推动企业落实环境法律法规政策的重要手段，是推动经济高质量发展的有效抓手，是贵州省现代环境治理八大体系之一。
            </p>
            <p>
              根据环保信用等级高低落实差异化监管措施。对信用较好、风险较低的企业，采取对行政审批、政府采购、评先评优等事项在同等条件下予以优先支持、适当降低“双随机”抽查比例和频次等方式，支持企业快速发展；对于违法失信、风险较高的企业，采取从严审批、不予政府采购、不予评先评优、适当提高“双随机”抽查比例和频次等措施，依法依规实施严管和惩戒。
            </p>
          </div>
        </div>
      </div>
      <div class="login_inputs">
        <div class="login_title">
          <!-- <div class="logo"><img src="../assets/logo1.png" alt="" /></div> -->
          <p v-if="formShow">欢迎登录使用</p>
          <p v-if="formPass">找回密码</p>
        </div>
        <el-form class="login_form" ref="loginFormRef" :model="loginFormModel" :rules="rules" v-show="formShow">
          <el-form-item prop="username">
            <el-input class="form_item" size="large" v-model="loginFormModel.username" prefix-icon="Avatar"
              placeholder="请输入登录名" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input class="form_item" size="large" v-model="loginFormModel.password" type="password"
              prefix-icon="Lock" placeholder="请输入密码" show-password autocomplete="new-password"></el-input>
          </el-form-item>
          <!-- <el-button @click="showCaptcha">验证</el-button> -->
          <el-form-item>
            <el-button class="form_item loginBtn" size="large" type="primary" :loading="state.loginLoading"
              @click="validateLogin(loginFormRef)">登录</el-button>
          </el-form-item>
          <el-form-item>
            <p class="retrieve-pass" @click="handleRetrievePass">找回密码</p>
          </el-form-item>
        </el-form>

        <!-- 找回密码 -->
        <el-form class="login_form" ref="retrieveFormRef" :model="retrieveFrom" :rules="rulesRetrieve"
          v-show="formPass">
          <el-form-item prop="LoginName">
            <el-input class="form_item" size="large" v-model="retrieveFrom.LoginName" prefix-icon="Avatar"
              placeholder="请输入登录账号"></el-input>
          </el-form-item>
          <el-form-item prop="Name">
            <el-input class="form_item" size="large" v-model="retrieveFrom.Name" prefix-icon="Stamp"
              placeholder="请输入个人或企业名称"></el-input>
            <span style="color: red; height: 60px; line-height: 60px">* 密码将以短信方式发送至您填写的信息接收手机号码</span>
          </el-form-item>
          <el-form-item>
            <el-button class="form_item loginBtn" size="large" type="primary" :loading="state.loginLoading"
              @click="validateRetrieve(retrieveFormRef)">确认提交</el-button>
          </el-form-item>
          <el-form-item>
            <p class="retrieve-pass" @click="handleBack">返回登录</p>
            <p class="retrieve-pass" style="margin-left: 10px" @click="handleAppeal">
              申诉找回
            </p>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-dialog v-model="dialogVisiblePass" title="当前的密码需要进行修改才能登录" width="30%">
      <el-form label-width="80px" :model="formNewText" style="max-width: 460px">
        <!-- <el-form-item label="用户名">
          <el-input autocomplete="off" v-model="formNewText.name" placeholder="请输入企业名称或个人姓名" />
        </el-form-item> -->
        <el-form-item label="登录名">
          <el-input autocomplete="off" v-model="formNewText.loginName" placeholder="请输入统一社会信用代码或个人姓名" />
        </el-form-item>
        <el-form-item label="旧密码">
          <el-input autocomplete="new-password" v-model="formNewText.oldPassword" type="password" placeholder="请输入旧密码"
            show-password />
        </el-form-item>
        <el-form-item label="新密码">
          <el-input autocomplete="new-password" v-model="formNewText.newPassword" type="password" placeholder="请输入新密码"
            show-password />
        </el-form-item>
      </el-form>
      <template #footer>
        <div style="text-align: center">
          <el-button style="width: 80%" type="primary" @click="handleEditPass">
            确认提交
          </el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 申诉找回 -->
    <el-dialog v-model="formFlag" title="申诉找回" width="30%">
      <el-form class="login_form" ref="appealRef" :model="appealForm">
        <el-form-item prop="companyName">
          <el-input class="form_item" size="large" v-model="appealForm.companyName" prefix-icon="HomeFilled"
            placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <el-form-item prop="orgCode">
          <el-input class="form_item" size="large" v-model="appealForm.orgCode" prefix-icon="List"
            placeholder="请输入信用代码"></el-input>
        </el-form-item>
        <el-form-item prop="linkMan">
          <el-input class="form_item" size="large" v-model="appealForm.linkMan" prefix-icon="Avatar"
            placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item prop="linkTel">
          <el-input class="form_item" size="large" v-model="appealForm.linkTel" prefix-icon="PhoneFilled"
            placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="fileUrl1" label="营业执照">
          <el-upload v-if="!appealForm.fileUrl1" action="#" :show-file-list="false" :http-request="handleUpload1">
            <el-button type="default" icon="Upload" size="small">上传说明文件</el-button>
          </el-upload>
          <div v-else>
            <el-link style="color: blue;" :href="baseUrl + appealForm.fileUrl1" :underline="false" target="_blank">
              {{ getFileName(appealForm.fileUrl1) }}
            </el-link>
            <span style="margin-left:10px; cursor:pointer;" @click="handleReset1">
              <el-icon style="vertical-align: middle;">
                <CircleCloseFilled />
              </el-icon>
            </span>
          </div>
        </el-form-item>
        <el-form-item prop="fileUrl2" label="申述说明">
          <el-upload v-if="!appealForm.fileUrl2" action="#" :show-file-list="false" :http-request="handleUpload2">
            <el-button type="default" icon="Upload" size="small">上传说明文件</el-button>
          </el-upload>
          <div v-else>
            <el-link style="color: blue;" :href="baseUrl + appealForm.fileUrl2" :underline="false" target="_blank">
              {{ getFileName(appealForm.fileUrl2) }}
            </el-link>
            <span style="margin-left:10px; cursor:pointer;" @click="handleReset2">
              <el-icon style="vertical-align: middle;">
                <CircleCloseFilled />
              </el-icon>
            </span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="handleOpenUrl">下载模板</el-button>
        </el-form-item>
      </el-form>
      <template #footer>
        <div style="text-align: center">
          <el-button style="width: 80%" type="primary" @click="handleSaveAppeal">
            确认提交
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { onBeforeUnmount, onUnmounted, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import api from '../http/apis'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
var CryptoJS = require('crypto-js')
import { CircleCloseFilled } from '@element-plus/icons-vue'

export default {
  setup() {
    const loginFormModel = reactive({ username: '', password: '' })
    const loginFormRef = ref(null)
    const retrieveFrom = reactive({ LoginName: '', Name: '' })
    const retrieveFormRef = ref(null)
    const formShow = ref(true)
    const formPass = ref(false)
    const formFlag = ref(false)
    const dialogVisiblePass = ref(false)
    const baseUrl = 'https://jk.hj.hjxy.org.cn'
    const appealForm = reactive({
      companyName: '',
      fileUrl1: '',
      fileUrl2: '',
      linkMan: '',
      linkTel: '',
      orgCode: '',
      FromSYS: '贵州环保信用评价',
    })
    const formNewText = reactive({

      loginName: '',
      oldPassword: '',
      newPassword: '',
    })
    const state = reactive({
      loginLoading: false,
    })
    const rules = {
      username: [
        {
          required: true,
          message: '请输入统一社会信用代码或个人姓名',
          trigger: 'blur',
        },
      ],
      password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
    }

    const rulesRetrieve = {
      LoginName: [
        { required: true, message: '请输入登录账号', trigger: 'chang' },
      ],
      Name: [
        { required: true, message: '请输入个人或企业名称', trigger: 'blur' },
      ],
    }

    const store = useStore()
    const router = useRouter()

    const handleOpenUrl = () => {
      window.open("http://221.10.90.140:8096/UploadFiles/File/%E7%8E%AF%E4%BF%9D%E4%BF%A1%E7%94%A8%E8%AF%84%E4%BB%B7.pdf");
    }

    const validateLogin = async (loginFormRef) => {
      if (!loginFormRef) {
        return
      }
      await loginFormRef.validate((valid, fields) => {
        if (valid) {
          const username = loginFormModel.username.trim()
          const password = loginFormModel.password.trim()
          submitLogin(username, password)
        }
      })
      // if (loginFormModel.password.trim() === '123@Ab' ||
      //   loginFormModel.password.trim() === 'eua1234' ||
      //   loginFormModel.password.trim() === '123456')
      //   {dialogVisiblePass.value = true}
      // else {
      //   await loginFormRef.validate((valid, fields) => {
      //     if (valid) {
      //       const username = loginFormModel.username.trim()
      //       const password = loginFormModel.password.trim()
      //       submitLogin(username, password)
      //     }
      //   })
      // }
    }

    const validateRetrieve = async (retrieveFormRef) => {
      if (!retrieveFormRef) {
        return
      }
      await retrieveFormRef.validate((valid, fields) => {
        if (valid) {
          submitRetrieve()
        }
      })
    }

    const getFileName = (str) => { //截取附件路径
      if (str) {
        return str.split('/').slice(-1)[0]
      } else {
        return ''
      }
    }

    async function submitRetrieve() {
      state.loginLoading = true
      const { data } = await api.userApi.getRetrievePass(retrieveFrom)
      if (data.isSuccessful) {
        ElMessage({
          message: '已找回密码,注意查收消息',
          type: 'success',
          grouping: true,
        })
        handleBack()
      } else {
        ElMessage({
          message: data.resultMsg || '未知错误，请联系管理员',
          type: 'error',
          grouping: true,
        })
      }
      state.loginLoading = false
    }

    async function submitLogin(username, password) {
      const AESkey = CryptoJS.enc.Utf8.parse('17bc357f2c5711a78629d6987fc64245')
      const encryptedUserName = CryptoJS.AES.encrypt(username.trim(), AESkey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
        iv: '',
      }).toString()
      const encryptedPassWord = CryptoJS.AES.encrypt(password.trim(), AESkey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
        iv: '',
      }).toString()
      console.info('encrypted', encryptedUserName, 'xxx', encryptedPassWord)

      // return;
      state.loginLoading = true
      const { data } = await api.userApi.login({
        loginName: encryptedUserName,
        password: encryptedPassWord,
      })
      state.loginLoading = false
      if (data.isSuccessful) {
        ElMessage({
          message: '登录成功',
          type: 'success',
          grouping: true,
        })
        sessionStorage.setItem('gzenv_token', data.resultData)
        store.dispatch('user/setUserMenu')
        store.commit('user/setUserInfo', data.resultObj)

        router.push('/system/defaultPage')


      } else if (data.resultData === 'PassWordRules') {
        ElMessage({
          message: data.resultMsg || '未知错误，请联系管理员',
          type: 'error',
          grouping: true,
        })
        dialogVisiblePass.value = true
      } else {
        ElMessage({
          message: data.resultMsg || '未知错误，请联系管理员',
          type: 'error',
          grouping: true,
        })
      }
    }

    const enterLogin = (e) => {
      if (e.key == 'Enter') {
        submitLogin(loginFormModel.username, loginFormModel.password)
      }
    }

    window.addEventListener('keypress', enterLogin)

    const handleRetrievePass = () => {
      formShow.value = false
      formPass.value = true
    }
    const handleBack = () => {
      formShow.value = true
      formPass.value = false
    }

    const handleEditPass = async () => {
      const { data } = await api.userApi.changePwd(formNewText)
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: 'success',
          grouping: true,
        })
      } else {
        ElMessage({
          message: data.resultMsg || '未知错误，请联系管理员',
          type: 'error',
          grouping: true,
        })
      }
      dialogVisiblePass.value = false
    }
    const handleAppeal = () => {
      formFlag.value = true
    }
    const handleReset1 = () => { // 重新上传附件1
      appealForm.fileUrl1 = ''
    }
    const handleReset2 = () => { // 重新上传附件2
      appealForm.fileUrl2 = ''
    }
    const handleUpload1 = async (val) => { // 上传附件1
      const fd = new FormData()
      const name = val.file.name.substring(0, val.file.name.lastIndexOf("."))
      fd.append('license', val.file)
      const dataObj = {
        path: 'user',
        secondPath: 'FindBack',
        fileName: name,
        file: fd,
      }
      const { data } = await api.userApi.findBackUploadFile(dataObj)
      if (data.isSuccessful) {
        appealForm.fileUrl1 = data.resultObj[0]
        ElMessage({
          message: data.resultMsg,
          type: 'success',
          grouping: true,
        })
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: 'error',
          grouping: true,
        })
      } else {
        ElMessage({
          message: '未知错误，请联系管理员',
          type: 'error',
          grouping: true,
        })
      }
    }

    const handleUpload2 = async (val) => { // 上传附件1
      const fd = new FormData()
      const name = val.file.name.substring(0, val.file.name.lastIndexOf("."))
      fd.append('explain', val.file)
      const dataObj = {
        path: 'user',
        secondPath: 'FindBack',
        fileName: name,
        file: fd,
      }
      const { data } = await api.userApi.findBackUploadFile(dataObj)
      if (data.isSuccessful) {
        appealForm.fileUrl2 = data.resultObj[0]
        ElMessage({
          message: data.resultMsg,
          type: 'success',
          grouping: true,
        })
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: 'error',
          grouping: true,
        })
      } else {
        ElMessage({
          message: '未知错误，请联系管理员',
          type: 'error',
          grouping: true,
        })
      }
    }

    const handleSaveAppeal = async () => {
      const { data } = await api.userApi.SaveHJUserFindBack(appealForm)
      if (data.isSuccessful) {
        console.log(data)
        ElMessage({
          message: data.resultMsg,
          type: 'success',
          grouping: true,
        })
        formFlag.value = false
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: 'error',
          grouping: true,
        })
      } else {
        ElMessage({
          message: '未知错误，请联系管理员',
          type: 'error',
          grouping: true,
        })
      }
    }


    onBeforeUnmount(() => {
      window.removeEventListener('keypress', enterLogin)
    })
    return {
      loginFormModel,
      loginFormRef,
      rules,
      rulesRetrieve,
      state,
      formShow,
      retrieveFrom,
      retrieveFormRef,
      validateLogin,
      handleRetrievePass,
      handleBack,
      validateRetrieve,
      dialogVisiblePass,
      formNewText,
      handleEditPass,
      handleAppeal,
      formFlag,
      formPass,
      getFileName,
      handleReset1,
      handleReset2,
      handleUpload1,
      handleUpload2,
      appealForm,
      handleSaveAppeal,
      baseUrl,
      handleOpenUrl
    }
  },

  // methods: {
  //   showCaptcha() {
  //     let appid = "2051163864"; // 腾讯云控制台中对应这个项目的 appid
  //     //生成一个滑块验证码对象
  //     let captcha = new TencentCaptcha(appid, function (res) {
  //       // 用户滑动结束或者关闭弹窗，腾讯返回的内容
  //       console.log(res);
  //       if (res.ret === 0) {
  //         //成功，传递数据给后台进行验证
  //       } else {
  //         // 提示用户完成验证
  //       }
  //     });
  //     // 滑块显示
  //     captcha.show();
  //   },
  // },
}
</script>

<style lang="sass" scoped>
@use "../assets/scss/login.scss" as *
</style>
